module.exports = __webpack_public_path__ + "static/img/linux-iso.e33375d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/linux-iso.png
// module id = eze3
// module chunks = 35